import api from '../../plugins/api';

const deleteMark = (params) => {
  return api.post('/api/crm/cars/deleteMark', params);
};

export default deleteMark;
